const LICENCE_KEY = {
  fullPage: "42DA9EF3-599246D3-966EC1B8-DBA3E5F3",
};

export { LICENCE_KEY };
